import styled from "@emotion/styled";
import { notSelect } from "../../../../styles/general";

const TopbarItem = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${notSelect}

  width: 26px;
  height: 26px;

  border-radius: 5px;
  background-color: ${(props) => (props.isActive ? "#fb972e" : "fff")};
  path,
  rect {
    fill: ${(props) => (props.isActive ? "white" : "black")};
  }

  &:hover {
    background-color: #fb972e;

    path,
    rect {
      fill: white !important;
    }
  }
`;

export default function TopBarItem({ onClick, isActive, children }) {
  return (
    <TopbarItem onClick={onClick} isActive={isActive}>
      {children}
    </TopbarItem>
  );
}
